import { Input } from "@nextui-org/react";
import React from "react";

const FrameworkInputFieldAccodian = ({
  id,
  data,
  setData,
  frameWorkDetails,
}) => {
  return (
    <>
    </>
  );
};

export default FrameworkInputFieldAccodian;
